














































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AdultMarketingPoints extends Vue {
    contentsMarketingPointTitle =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/marketing-title.webp'
}
